import { Role } from './roles.interface'
import { HandbookResolver, MappingBaseMaterialComponent, OrganizationResolver } from '@surgetech-eu/core'
import { PlayerGuard } from '../cmpman/certification/player.guard'
import {ComponentModule} from "../cmpman/component/component.module";
const KEYEorCMPMANSpecificRoutes = {
    certificationPlayerRoute: PlayerGuard.isKEYEorCMPMAN
        ? [
              {
                  name: 'player',
                  route: ['/', 'cmpman', 'certification', 'player'],
                  title: 'Player'
              }
          ]
        : []
}

export const CmpmanRole: Role = {
    name: 'cmpman',
    title: 'Component Manufacturer',
    icon: 'ion-ios-calculator',
    pages: [
        {
            title: 'Component/Raw Material',
            name: 'component',
            icon: 'ion-ios-refresh',
            children: [
                {
                    route: ['/', 'component', 'prepare'],
                    title: 'Prepare',
                    name: 'prepare'
                },
                {
                    route: ['/', 'component', 'manage'],
                    title: 'Manage',
                    name: 'manage'
                },
                {
                    route: ['/', 'component', 'view'],
                    title: 'View',
                    name: 'view'
                },
                {
                    route: ['/', 'component', 'mapping'],
                    title: 'Mapping',
                    name: 'mapping'
                }
            ]
        },
        {
            route: ['/', 'tech-drawing'],
            title: 'Technical Drawing',
            name: 'techDesign',
            icon: 'ion-ios-paper'
        },
        {
            route: ['/', 'cmpman', 'mapping', 'base-material'],
            title: 'Base Material',
            name: 'baseMaterial',
            icon: 'ion-ios-paper'
        },
        {
            title: 'Certification',
            name: 'certification',
            icon: 'ion-document-text',
            children: [
                {
                    name: 'select-and-create',
                    route: ['/', 'cmpman', 'certification', 'select-and-create'],
                    title: 'Select and Create'
                },
                {
                    name: 'upload-and-create',
                    route: ['/', 'cmpman', 'certification', 'upload-and-create'],
                    title: 'Upload and Create'
                },
                ...KEYEorCMPMANSpecificRoutes.certificationPlayerRoute,
                {
                    name: 'view',
                    route: ['/', 'cmpman', 'certification', 'view'],
                    title: 'View'
                },
                {
                    name: 'base-material-certification',
                    route: ['/', 'cmpman', 'certification', 'base-material-certification'],
                    title: 'Base Material'
                }
            ]
        },
        {
            route: ['/', 'cmpman', 'history', 'eyewear'],
            title: 'History',
            name: 'history',
            icon: 'ion-ios-clock'
        }
    ],
    modules: {
        commonModules: [
            {
                path: 'component',
                name: 'ComponentModule',
                load: () => import ('../cmpman/component/component.module').then(m => m.ComponentModule)
            },
            {
                path: 'tech-drawing',
                name: 'TechDesignModule',
                load: () => import ('../cmpman/tech-drawing/tech-drawing.module').then(m => m.TechDesignModule)
            },
            {
                path: 'certification',
                url: 'cmpman/certification',
                name: 'CertificationModule',
                load: () => import ('../cmpman/certification/certification.module').then(m => m.CertificationModule)
            },
            {
                path: 'history',
                url: 'cmpman/history',
                name: 'HistoryModule',
                load: () => import ('../cmpman/history/history.module').then(m => m.HistoryModule)
            }
        ],
        externalModules: [
            {
                path: 'cmpman/mapping',
                childPath: 'base-material',
                component: MappingBaseMaterialComponent,
                resolve: {
                    handbook: HandbookResolver,
                    organizations: OrganizationResolver
                }
            }
        ]
    }
}
